export const MUTATION_DELETE_PARTNER = /* GraphQL */ `
	mutation ($id: String!) {
		deletePartner(id: $id)
	}
`;
